<template>
  <div id="wholeArea">
    <div :style="{display:isCommentHistoryRight ? 'inline-block': 'block', 'vertical-align':isCommentHistoryRight ? 'top': 'initial'}">
      <div class="iframe-wrap-wrap" :class="iframeWrapWrapClass">
        <!--/* 
          forkstyle.comをiframe表示する場合はsandboxを付与しない（sandboxをつけるとoriginがnullになり、javascriptからcookieにアクセスできなくなる。もちろん、same-originは絶対付与してはいけないのでsandboxは使用できない）
        */-->
        <div class="iframe-parent" :style="iframeWrapStyle">
          <iframe
            style="position:absolute;top:1;left:1;border:none;box-sizing: content-box;transform-origin: 0 0;user-select: none;" :style="iframeStyle"
            :src="kiwiIframeURL"
            frameborder="1"
            scrolling="no"
            id="viewIframe"
            allow="autoplay;camera *;microphone *;geolocation;"
          />
          <Loading ref="loading" class="loading" :fadein="false" />
        </div>
      </div>
      <div v-if="!isCommentHistoryRight">
        <Description 
          :showDescription="showDescription"
          :publicPageData="publicPageData"
        />
      </div>
    </div>

    <!--/* コメント 履歴*/-->
    <div :style="commentHistoryWrapStyle">
      <CommentHistory 
        ref="commentHistory"
        :isPreview="isPreview"
        :isRightPosition="isCommentHistoryRight"
      />
    </div>
    
    <div v-if="isCommentHistoryRight">
      <Description 
        :showDescription="showDescription"
        :publicPageData="publicPageData"
      />
    </div>
    <div id="commentInput" class="bottom-comment-input" :style="commentInputStyle">
      <textarea
        style="resize: vertical;"
        rows="1"
        class="form-control"
        name="content"
        v-model="commentInputText"
        type="text"
        :placeholder="$root.account.isLogin ? 'コメント欄は広げることができます' : 'コメントするにはログインしてください'"
        :maxlength="$root.const.commnentMaxLen"
        :disabled="!$root.account.isLogin"
        @keydown.stop="preventKeyEventToIframe"
        @keypress.stop="preventKeyEventToIframe"
        @keyup.stop="preventKeyEventToIframe"
      />
      <button class="btn btn-primary" style="margin-left:8px;overflow: hidden;font-size:smaller; padding:8px 2px;" @click="onComment" :disabled="!$root.account.isLogin || !commentInputText || isPreview">
        コメント
      </button>
    </div>
  </div>
</template>


<script lang="ts">
import { Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import CommentHistory from "@/pages/publicPage/_component/CommentHistory.vue";
import PublicPageResp from "@/interface/api/PublicPageResp";
import { RouteLocationNormalized } from 'vue-router';
import OnUrlChangeVue from '@/OnUrlChangeVue';
import {FMInitialized, FMSize, FMSetLayout} from '@/interface/kiwi/ForkstyleMessage';
import { Ref } from 'vue-property-decorator';

import Description from "@/pages/publicPage/_component/Description.vue";
import common from '@/common';
import { PublicPageLayoutSize } from '@/types/PublicPageLayoutSize';
import PublicPageStandardVue from '@/pages/publicPage/_interface/PublicPageStandardVue';
import CommentResp from '@/interface/api/CommentResp';
import Loading from "@/component/Loading.vue";



//HTMLのサイズを変更したら一緒に変更する
const DIV_SPAN_X = 4 //iframeの親Divとコメント欄との間
const DIV_SPAN_Y = 4 //iframeの親Divとコメント欄との間
const COMMENT_RIGHT_MIN_WIDTH = 250
const COMMENT_BOTTOM_MIN_HEIGHT = 60
const BORDER_LEN = 1
const COMMENT_INPUT_TOP_BOTTOM_MARGIN = 8


@Options({ 
  components: { CommentHistory, Description, Loading },
  props:{
    publicPageData:{
      type:Object
    },
    isPreview:{
      type:Boolean,
      default:false,
    },
    kiwiIframeURL:{
      type:String
    },
    publicPageTitle:{
      type:String
    },
    projectUserName:{
      type:String
    },
    viewLayoutRequest:{
      type:Object
    },
    commentOK:{
      type:Function
    },
  }
})
export default class extends OnUrlChangeVue implements PublicPageStandardVue {
  // @ts-expect-error
  $root: RootVue;
  readonly publicPageData!: PublicPageResp;
  readonly isPreview!: boolean;
  readonly publicPageTitle!: string;
  readonly projectUserName!: string;
  readonly viewLayoutRequest!: null|FMSetLayout;
  readonly commentOK!: Function;
  readonly kiwiIframeURL!: string;

  //mounted前のlifesycleだと初期化されていないので使用できない点に注意
  @Ref() readonly commentHistory = null as any as CommentHistory;
  @Ref() readonly loading = null as any as Loading;
  
  PublicPageLayoutSize = PublicPageLayoutSize;

  showDescription = false
  commentInputText = "";

  //dom操作や検索は多少重いのでキャッシュしておく（10年前の発想）
  wholeArea: HTMLElement|null = null;
  commentInput: HTMLElement|null = null;

  isCommentHistoryRight = false
  iframeStyle = {};//width,heightはコンテンツの実値、transformに倍率を設定する
  iframeWrapStyle = {} // iframeWHStyleでの倍率込の値を設定する。iframeを拡大して表示すると、他の表示領域とかぶってしまうのでそれを防ぐ。

  commentHistoryWrapStyle = {}
  commentInputStyle = {}

  get borderLen(){
    return this.publicPageData.layoutBorder ? BORDER_LEN * 2 : 0
  }

  get iframeWrapWrapClass(){
    return (this.publicPageData.layoutBorder ? 'iframe-wrap-wrap-border':'')
     + (this.publicPageData.layoutSize === PublicPageLayoutSize.FIXED_DETECT && (!this.loading || this.loading.isNowLoading()) ? ' iframe-wrap-wrap-loading': '')
  }

  resizeLayout(viewSize:FMSize){
    if(!this.wholeArea){
      this.wholeArea = document.getElementById('wholeArea');
      this.commentInput = document.getElementById('commentInput');
    }
    if(this.wholeArea){
      const minAreaHeight = 200
      // const isBeforeRight = this.isCommentHistoryRight
      var rect = this.wholeArea.getBoundingClientRect(); 
      var bodyRect = document.body.getBoundingClientRect()//スクロールした場合に位置がずれないよう差分計算に使用する
      
      // console.info(" this.wholeArea.clientWidth",  this.wholeArea.clientWidth)
      // console.info(" this.$root.common.getWindowHeight()",  this.$root.common.getWindowHeight())
      // console.info(" rect.top",  rect.top, bodyRect.top)
      this.setStyles(
        viewSize,
        this.wholeArea.clientWidth - this.borderLen, 
        Math.max(minAreaHeight, this.$root.common.getWindowHeight() - (rect.top - bodyRect.top))
      )

    }else{
      this.$nextTick(()=>{
        this.resizeLayout(viewSize)
      })
    }
  }

  setStyles(viewSize:FMSize, areaWidth:number, areaHeigtht:number){
    // console.log("--------------")
    // console.log("area", areaWidth, areaHeigtht)

    let layoutSizeX;
    let layoutSizeY;
    switch(this.publicPageData.layoutSize){
      case PublicPageLayoutSize.FIXED_DETECT:
        layoutSizeX = viewSize.width === undefined ? 0 : viewSize.width
        layoutSizeY = viewSize.height=== undefined ? 0 : viewSize.height
      break;
      case PublicPageLayoutSize.FIXED_SIZE:
        layoutSizeX = this.publicPageData.layoutSizeX as number
        layoutSizeY = this.publicPageData.layoutSizeY as number
        if(common.isNullOrUndefined(layoutSizeX)) layoutSizeX = 500
        if(common.isNullOrUndefined(layoutSizeY)) layoutSizeY = 500
      break;
      case PublicPageLayoutSize.RESPONSIVE:
        throw "error"
    }

    const commentInputHeight = this.commentInput!.clientHeight + COMMENT_INPUT_TOP_BOTTOM_MARGIN;
    let scale;
    //zoomする場合
    if(this.publicPageData.layoutZoom){

      //コメントが右に来る場合の残り幅
      const restRWidth = areaWidth - DIV_SPAN_X - COMMENT_RIGHT_MIN_WIDTH - this.borderLen
      const restRHeight = areaHeigtht - commentInputHeight - this.borderLen
      //コメントが下に来る場合の残り幅
      const restBWidth = areaWidth - this.borderLen
      const restBHeight = areaHeigtht - DIV_SPAN_Y - COMMENT_BOTTOM_MIN_HEIGHT - commentInputHeight - this.borderLen
      
      //残り幅から、コメントが右に来る場合と下に来る場合に、それぞれどこまで拡大可能かを計算
      const scaleRcomment = Math.min( restRWidth / layoutSizeX, restRHeight / layoutSizeY )
      const scaleBcomment = Math.min( restBWidth / layoutSizeX, restBHeight / layoutSizeY )
      // console.log("R", restRWidth, restRHeight, restRWidth / layoutSizeX, restRHeight / layoutSizeY)
      // console.log("B", restBWidth, restBHeight, restBWidth / layoutSizeX, restBHeight / layoutSizeY)
      // console.log("scale", scaleRcomment, scaleBcomment)

      //コメントを横、下どちらに配置するほうが拡大表示できるかの判定
      this.isCommentHistoryRight = scaleRcomment > scaleBcomment
      //cssに設定する値なので適当なところで小数点を捨てる
      scale = this.isCommentHistoryRight ?scaleRcomment : scaleBcomment
      this.setIframeStyles(layoutSizeX, layoutSizeY, scale)
    
    //zoomしない場合
    }else{
      //指定されたpxをそのまま使用する
      scale = 1
      //右にコメントが入ればそっちに入れる
      this.isCommentHistoryRight = areaWidth - layoutSizeX - DIV_SPAN_X - COMMENT_RIGHT_MIN_WIDTH  > 0
      this.setIframeStyles(layoutSizeX, layoutSizeY)
    }

    //自動サイズ取得の初期化前（サイズ未取得時）にコメント欄を右側に表示しない
    if(this.publicPageData.layoutSize === PublicPageLayoutSize.FIXED_DETECT && viewSize.width === undefined){
      this.isCommentHistoryRight = false
    }
    // console.log("right", areaWidth ,layoutSizeX, DIV_SPAN_X, COMMENT_RIGHT_MIN_WIDTH)

    if(this.isCommentHistoryRight){
      //コメント履歴を設定。倍率の関係で残った横幅を設定する
      this.setRightComment(
        layoutSizeX * scale,
        areaWidth - DIV_SPAN_X - layoutSizeX * scale - this.borderLen,
        layoutSizeY * scale
      )
    }else{
      //コメントの高さを設定。倍率の関係で残った縦幅を設定する
      this.setBottomComment(
        layoutSizeX * scale, 
        areaHeigtht - DIV_SPAN_Y - layoutSizeY * scale - this.borderLen - commentInputHeight
      )
    }
  }

  setIframeStyles(w:number, h:number, scale = 1){
  // console.log("iframe", w, h, scale)
    this.iframeStyle = scale === 1 ? {
      'width':w + 'px', 
      'height': h + 'px',
    }:{
      'width':w + 'px', 
      'height': h + 'px',
      'transform': `scale(${scale.toString().substr(0, 7)})`
    }
    this.iframeWrapStyle = {
      'width':(scale * w).toString().substr(0, 7) + 'px', //iframe親とiframeに1pxの幅があるので、そのぶん1px、左右で2pxを加えていた。。。が間違いっぽかったので消した
      'height': (scale * h).toString().substr(0, 7) + 'px', //iframe親とiframeに1pxの幅があるので、そのぶん1px、上下で2pxを加えている。。。が間違いっぽかったので消した
      'border': (w && this.publicPageData.layoutBorder) ? '1px solid #999' : 'none',
    }
  }

  setRightComment(iframeWidth:number, commentHistoryWidth:number, commentHistoryHeight:number){
    this.commentInputStyle = {
      'min-width':iframeWidth + 'px',
      'max-width':'96%',
      //コメントの縦幅に含めるためにmarginではなくpaddingを使用
      'padding-top': DIV_SPAN_Y + 'px',
      'padding-bottom': DIV_SPAN_Y + 'px',
    }
    this.commentHistoryWrapStyle = {
      'width':commentHistoryWidth + 'px',
      'height': commentHistoryHeight + 'px',
      'display': 'inline-block',
      'vertical-align': 'top',
    }
  }
  setBottomComment(iframeWidth:number, commentHistoryHeight:number){
    this.commentInputStyle = {
      'min-width':iframeWidth + 'px',
      //コメントの縦幅に含めるためにmarginではなくpaddingを使用
      'padding-top': DIV_SPAN_Y + 'px',
      'padding-bottom': DIV_SPAN_Y + 'px',
    }
    this.commentHistoryWrapStyle = {
      'width':'100%',
      'height': commentHistoryHeight + 'px',
      'display': 'block',
      'margin-left': 'auto',
      'margin-right': 'auto',
      'margin-top': DIV_SPAN_Y + 'px',
    }
  }

  getHeaderRedText(){
    return this.showDescription ? "詳細を閉じる":"詳細を開く";
  }

  onHeaderClick(){
    this.showDescription = !this.showDescription
    this.$root.commonHeader.headerTitle.setTitleText(this.getHeaderRedText(), this.publicPageData.title)
  }

  init(){
    this.$root.commonHeader.headerTitle.setTitleText(this.getHeaderRedText(), this.publicPageData.title)
    this.resizeLayout({} as FMSize)
  }

  //継承元から呼び出される
  onUrlChanged(_newVal: RouteLocationNormalized, _oldVal: RouteLocationNormalized) {
    this.init()
  }
  
  onComment(){
    this.commentOK(this.commentInputText).then(()=>{
      this.commentInputText = ""
    })
  }

  public onViewNotFound(){
    this.loading?.finish()
  }

  public onViewInitialized(_data: FMInitialized){
    //とくになにもしない
  }
  public clearIframeSize(){
    if(this.publicPageData.layoutSize === PublicPageLayoutSize.FIXED_DETECT){
      //画面サイズが変更された時にiframeに高さが指定されていると、iframe子側でも正確にスクロールサイズが計算されなくなる。
      //このためサイズをクリアした状態でサイズ送信を要求する。
      this.iframeStyle = {
        'width': '100%', 
        'height': 'initial',
        'opacity': 0.2,
      };
    }
  }

  public onViewSizeChanged(data: FMSize){
    this.loading.finish()
    this.resizeLayout(data)
  }

  public addComment(comment:CommentResp){
    if(this.commentHistory){
      this.commentHistory.addComment(comment)
    }else{
      //本番環境ではたぶん不要だけど、開発環境だとホットリロード時にthis.commentHistoryの参照が失われてエラーになる対策
      setTimeout(()=>{
        this.addComment(comment)
      }, 10)
    }
  }
  
  public getIframe():HTMLIFrameElement{
    return document.getElementById("viewIframe") as any;
  }

  created() {
    this.$root.commonHeader.headerTitle.addTitleClickListener(this.onHeaderClick) 
    
    this.init();
  }
  
  //ダミー関数。テキスト入力中はiframeにキーを流さない
  preventKeyEventToIframe(){}

  beforeUnmount(){
    this.$root.commonHeader.headerTitle.clearTitle()
  }

}
</script>

<style lang="scss" scoped>
#wholeArea{
  max-width:96%;
  margin-right: auto;
  margin-left: auto;
  padding: 0;

  /* inline-block間のスペース（font-sizeあり）がbuild時に取り除かれてしまうので、build前でもスペースのサイズを0にして同一レイアウト表示にする */
  font-size: 0;
  white-space: nowrap;
  > * {
    font-size: 1rem;
    white-space: initial;
  }
  
  @media (max-width: 768px) {
    max-width:98%;
  }
  @media (max-width: 576px) {
    max-width:100%;
  }
}

.visibility-hidden{
  visibility: hidden;
}
.bottom-comment-input {
  display: flex;
  width:100%;
  align-items: start;
  margin-right: auto;
}

.iframe-wrap-wrap{
  margin-left: auto;
  margin-right: auto;
  user-select: none;
}
.iframe-wrap-wrap-border{
  background-color: #000;
}
.iframe-wrap-wrap-loading{
  padding:20px;
  min-height: 80px;
  background-color: initial;
}

.iframe-parent{
  position:relative;
  box-sizing: content-box;
  margin:auto;
  background-color: #fff;
  user-select:none;
}

.loading {
  position:absolute;
  top:3%;
  left:50%;
  transform:translateX(-50%);
}
</style>
